<template>
  <div>
    <h1>Reports</h1>
    <br />
    <div id="dashboards"></div>
    <div class="ph-item" v-if="isLoaded">
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-4"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import { getUser } from "@/utils/getUser";
import QsDashboardService from "@/services/qsDashboardService";
import CwDashboardService from "@/services/cwDashboardService";
import { embedDashboard } from "amazon-quicksight-embedding-sdk";

function greeting() {
  const d = new Date();
  const time = d.getHours();
  if (time < 12) {
    return "God morgon";
  }
  if (time > 12) {
    return "God eftermiddag";
  }
  if (time > 18) {
    return "God kväll";
  }
  if (time > 18) {
    return "God kväll";
  }
}

export default Vue.extend({
  data() {
    const user = getUser();
    console.log(user);
    return {
      user: user.username,
      greeting: greeting(),
      isLoaded: false
    };
  },
  async created() {
    const jwt = window.localStorage.getItem("jwt");
    const cw = new CwDashboardService(jwt);

    try {
      this.isLoaded = true;
      // Load cloudwatch cross account dashboards
      const cwResponse = await cw.getDashboards();

      // Parent element for dashboards
      const dashboardParent = document.getElementById("dashboards");

      if (cwResponse.status == 400) {
        // dashboardParent.InnerHTML = "<h5>No reports found</h5>";
      } else {
        /*
        Loop through the preview urls,
        add a div container and then
        initiate the dashboard in that container */
        for (const [i, entry] of cwResponse.data.urls.entries()) {
          const id = `cloudwatch-dashboard-${i}`;
          const div = document.createElement("div");
          div.id = id;
          div.className = "clouddwatch-dashboard-item";
          dashboardParent.appendChild(div);

          const img = document.createElement("img");
          img.alt = entry.name;
          img.title = entry.name;
          if (entry.preview) {
            img.src = entry.preview;
          }

          cw.getDashboard(entry.url).then(res => {
            if (res.data.indexOf("https://") !== -1) {
              img.src = res.data;
            } else {
              img.src = "data:image/png;base64, " + res.data;
            }
          });

          if (entry.sharedUrl) {
            const link = document.createElement("a");
            link.href = entry.sharedUrl;
            link.target = "_blank";
            link.appendChild(img);
            div.appendChild(link);
          } else {
            div.appendChild(img);
          }
        }
      }
    } catch (ex) {
      console.error(ex.message);
    }

    const qs = new QsDashboardService(jwt);

    try {
      this.isLoaded = true;
      // Load quicksight cross account dashboards
      const qsResponse = await qs.getDashboards();

      // hide preloader

      // Parent element for dashboards
      const dashboardParent = document.getElementById("dashboards");

      if (qsResponse.status == 400) {
        // dashboardParent.InnerHTML = "<h5>No reports found</h5>";
      } else {
        /*
        Loop through the embed urls,
        add a div container and then
        initiate the dashboard in that container */
        for (const [i, entry] of qsResponse.data.urls.entries()) {
          const id = `quicksight-dashboard-${i}`;
          const div = document.createElement("div");
          div.id = id;
          dashboardParent.appendChild(div);

          // Load dashboard
          const dashboard = embedDashboard({
            url: entry.url,
            container: div,
            undoRedoDisabled: false,
            resetDisabled: false,
            locale: "en-EU",
            parameters: {
              country: "Sweden"
            },
            width: "100%",
            height: "AutoFit",
            loadingHeight: "700px"
          });

          // Check error occurred
          dashboard.on("error", error => {
            console.error(error);
          });
        }
      }
    } catch (ex) {
      console.error(ex.message);
    }

    setInterval(()=>{
      this.isLoaded = false;
    },3000)
  }
});
</script>

<style lang="scss">
$ph-color: red;
h1 {
  border-bottom: 2px solid var(--tq-blue);
  padding-bottom: 8px;
}
.clouddwatch-dashboard-item {
  background-color: #f6f6f6;
  padding: 10px;
  img {
    border: 2px solid #c0c0c0;
    max-width: 100%;
  }
}
</style>
